import { render, staticRenderFns } from "./TestPatternText.vue?vue&type=template&id=c117d7de&scoped=true"
import script from "./TestPatternText.vue?vue&type=script&lang=js"
export * from "./TestPatternText.vue?vue&type=script&lang=js"
import style0 from "./TestPatternText.vue?vue&type=style&index=0&id=c117d7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c117d7de",
  null
  
)

export default component.exports